import { render, staticRenderFns } from "./PurchaseReturnInvoice.vue?vue&type=template&id=ea73a94c&scoped=true&"
import script from "./PurchaseReturnInvoice.vue?vue&type=script&lang=js&"
export * from "./PurchaseReturnInvoice.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseReturnInvoice.vue?vue&type=style&index=0&id=ea73a94c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea73a94c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
